import { Component, ChangeDetectionStrategy, OnInit, Input, HostBinding } from '@angular/core';
import { DataTableBodyRowComponent } from '@swimlane/ngx-datatable';
import { GridBodyCardRowDirective } from './card-row.directive';

@Component({
  selector: 'rdatatable-body-card-row',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './body-card-row.html',
})
export class RDataTableBodyCardRowComponent extends DataTableBodyRowComponent implements OnInit {
  @Input() pageSize!: number;
  @Input() offset!: number;
  @Input() rowTemplate!: GridBodyCardRowDirective;

  @HostBinding('style.width.px')
  get columnsTotalWidths(): string {
    return '100%';
  }
  ngOnInit() {}
  cardViewAction(row: any) {}
}
